import React from 'react';
import { AiOutlineLeft } from 'react-icons/ai';
import styles from '../styles.module.scss';

type Props = {
  sticky: boolean;
  onClick: () => void;
};

const ConsultationBackButton = ({ sticky, onClick }: Props): JSX.Element => {
  return (
    <button
      type="button"
      className={`fs-unmask ${sticky ? styles.backBtnSticky : styles.backBtn}`}
      onClick={onClick}
    >
      <AiOutlineLeft /> Back
    </button>
  );
};

export default ConsultationBackButton;